/*
 *
 * SignUpPage constants
 *
 */

export const SIGN_UP_REQUEST = 'src/SelfSignUp/SIGN_UP_REQUEST';
export const SIGN_UP_SUCCESS = 'src/SelfSignUp/SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'src/SelfSignUp/SIGN_UP_FAILURE';
export const RESEND_VERIFICATION_REQUEST =
  "src/SignUpPage/RESEND_VERIFICATION_REQUEST";
export const RESEND_VERIFICATION_SUCCESS =
  "src/SignUpPage/RESEND_VERIFICATION_SUCCESS";
export const RESEND_VERIFICATION_FAILURE =
  "src/SignUpPage/RESEND_VERIFICATION_FAILURE";
  export const ACCOUNT_VERIFICATION_REQUEST = "src/ConfirmEmailPage/ACCOUNT_VERIFICATION_REQUEST";
  export const ACCOUNT_VERIFICATION_SUCCESS = "src/ConfirmEmailPage/ACCOUNT_VERIFICATION_SUCCESS";
  export const ACCOUNT_VERIFICATION_FAILURE = "src/ConfirmEmailPage/ACCOUNT_VERIFICATION_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/SelfSignUp/constants.js